/**
 * Created by xiaojielin on 17/1/4.
 */
const utils = {}
utils.isEmptyObject = function (obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

utils.randomString = function (length) {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}

export default utils



// WEBPACK FOOTER //
// ./src/utils/common.js